// @ts-nocheck
import React, { useState } from 'react';
import { useAuth } from '@/auth/clerkShim';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import useGameStore from '@/store/gameStore';

// Inline per-game manual score entry (home – away + Save). Used for pickleball
// games so an admin can key a single game's score without scanning a sheet.
export default function ManualScoreEntry({ game, onSaved }) {
  const { getToken } = useAuth();
  const updateGame = useGameStore((s) => s.updateGame(getToken));
  const [home, setHome] = useState(game.homeScore ?? '');
  const [away, setAway] = useState(game.awayScore ?? '');
  const [saving, setSaving] = useState(false);

  const norm = (v) => (v === '' || v == null ? '' : String(v));
  const dirty = norm(home) !== norm(game.homeScore) || norm(away) !== norm(game.awayScore);

  const save = async () => {
    if (saving || !dirty) return;
    setSaving(true);
    try {
      // updateGame unwraps populated team refs via helpers.getObjId internally.
      await updateGame({
        ...game,
        homeScore: home === '' ? null : Number(home),
        awayScore: away === '' ? null : Number(away),
      });
      onSaved && onSaved();
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex items-center gap-1.5">
      <Input
        type="text" inputMode="numeric" aria-label="Home score"
        className="h-8 w-14 text-center" value={home}
        onChange={(e) => setHome(e.target.value.replace(/[^0-9]/g, ''))}
      />
      <span className="text-muted-foreground text-sm">–</span>
      <Input
        type="text" inputMode="numeric" aria-label="Away score"
        className="h-8 w-14 text-center" value={away}
        onChange={(e) => setAway(e.target.value.replace(/[^0-9]/g, ''))}
      />
      <Button size="sm" variant="secondary" onClick={save} disabled={!dirty || saving}>
        {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Save'}
      </Button>
    </div>
  );
}
